import router from './router'
import store from './store'
import checkToken from '@/utils/checkToken'
import { MessageBox, Message } from 'element-ui'

const whiteList = ['/index']

async function routerBeforeEach(to, from, next) {

  if (true) {
    if (to.name === 'Index') {
      next()
    } else {
      if (to.meta.auth) {
        return new Promise((resolve, reject) => {
          checkToken(to).then(res => {
            next()
            resolve()
          },rej=> {
            console.log(rej)
          }).catch(reject=> {
            console.log(reject)
          })
        })
      }else{
        next()
      }

      /*// 获取店铺状态
      const status = await API_Shop.getShopStatus()
      if (status === 'OPEN') {
        const shopInfo = Storage.getItem('seller_shop')
        if (!shopInfo) await store.dispatch('getShopInfoAction')
        if (store.getters.addRouters.length === 0) {
          store.dispatch('GenerateRoutes').then(() => {
            router.addRoutes(store.getters.addRouters)
            next({ ...to, replace: true })
          }).catch(() => {
            errorMsg('验证失败，请重新登录！', '登录出错')
          })
        } else {
          next()
        }
      } else if (status === 'CLOSED') {
        errorMsg('您的店铺已被关闭，请联系管理员！')
      } else if (status === 'APPLY' || status === 'APPLYING') {
        errorMsg('您的店铺正在申请中，请稍后再试！')
      } else if (status === 'REFUSED') {
        errorMsg('您的开店申请被拒绝，请重新申请或联系管理员！')
      } else {
        store.dispatch('fedLogoutAction')
        MessageBox.confirm('账号尚未申请开店！', '出现错误', {
          confirmButtonText: '去开店',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          location.replace(`${domain.buyer_pc}/shop/apply`)
        })
      }*/
      next()
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/index')
    }
  }
}

/*const errorMsg = (msg, title = '权限错误') => {
  store.dispatch('fedLogoutAction')
  MessageBox.alert(msg, title, {
    type: 'error',
    callback: () => {
      location.replace(`/login?forward=${location.pathname}`)
    }
  })
}*/

async function routerAfterEach(to, from, next) {
  window.scrollTo(0, 0)
}

router.beforeEach(routerBeforeEach)

router.afterEach(routerAfterEach)
